import type { FC, PropsWithChildren } from 'react'
import { Box, Container } from "@chakra-ui/react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

export const BaseLayout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Container maxW={1220}>
      <Header mb={4}/>
      <Box as='section'>
        {children} 
      </Box>
      <Box as='footer' mt={24} minHeight={'10vh'}>
        <Footer  />  
      </Box>
    </Container>
  );
}